module.exports = __webpack_public_path__ + "img/public/SiteIcons/listSeaechIcon.svg?ed512f0a";